import FAVICONS from 'shared/favicons';
import {CurrentUserClass} from 'shared/CurrentUser';
import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';
import {MAIN_CALENDAR_URL_PREFIX, MAIN_EVENT_URL_PREFIX} from './config';
import {
    getEventDetailPageChildren,
    getEventDetailPageRecords,
    EVENT_NAME_PREFIX_META
} from '../new_event/eventDetailPageChildren';

const CALENDAR_PAGE_CHILDREN = [
    {
        name: 'calendar',
        path: '',
        component: () => import(/* webpackChunkName: "calendar" */ './CalendarPageCalendar.vue'),
        props: true
    },
    {
        name: 'CalendarPageSearch',
        path: 'search/',
        component: () => import(/* webpackChunkName: "calendar" */ './CalendarPageSearch.vue'),
        props: true
    },
];

export default defineSection({
    head: sectionHead({title: 'Calendar', icon: FAVICONS.calendar}),
    routes: [
        ...getEventDetailPageRecords('', ({pathTail, namePrefix}) => ({
            path: MAIN_EVENT_URL_PREFIX + pathTail,
            component: () => import(/* webpackChunkName: "eventDetail" */ '../new_event/EventDetailPage'),
            props: true,
            meta: {[EVENT_NAME_PREFIX_META]: namePrefix},
            children: getEventDetailPageChildren(namePrefix)
        })),
        {
            path: MAIN_CALENDAR_URL_PREFIX,
            component: () => import(/* webpackChunkName: "calendar" */ './CalendarPage.vue'),
            props: route => {
                return {userId: route.params.userId === 'my' ? new CurrentUserClass().id : route.params.userId + ''};
            },
            children: CALENDAR_PAGE_CHILDREN
        },
        {
            path: '/calendar/list/',
            component: () => import(/* webpackChunkName: "calendar" */ '../ManagedCalendarsList'),
            props: true,
            name: 'CalendarsIManage'
        },
        {
            // Django serves bare /calendar/ as `my_calendar`, but the calendar itself always
            // lives under a userId, so send it to the viewer's own one instead of rendering
            // an empty page.
            path: '/calendar/',
            redirect: '/calendar/my/'
        },
    ]
});
